/* Fuel_11, decides and keeps current the same day shipping line.

   This file owns row one's sentence. Liquid prints the countdown copy and,
   while it has a number missing from it, holds it invisible with
   f11-urgency__text--pending; this script writes the finished sentence into
   the same span and takes the class off. It never creates, moves or removes a
   row, so no sentence it writes can change the module's height: while the
   module is showing, that height belongs to the viewport alone, 58px at 376px
   and wider and 74px below that, and it is the same whether this file runs,
   fails, or is never fetched at all. Blocked at the network, handed a zone
   name that is not a real zone, and run with Intl deleted, the module measures
   the same and row one simply stays blank.
   Fuel_07 shipped a variant that moved content after paint and it cost layout
   shift, so the sentence is kept clear of the height rather than timed around.
   Hiding the module outright is the one thing in this file that does move the
   page, and it is a deliberate trade. See "when the module is hidden" below.

   What the line says, always in the zone the setting names and never on the
   shop's or the visitor's clock:

     a shipping day, before the cutoff, a minute or more left
       the countdown copy with [time] replaced, "Order within 7h:56m for
       same-day shipping". Copy written without the token has no number to
       carry, so it is said exactly as the merchant typed it.
     a shipping day, under a minute left
       the last minute copy, "Order now, ships today". A same day countdown
       that would read 0h:00m is never printed.
     anything else, which is after the cutoff, a weekend or a holiday
       the next day copy with [day] replaced by the name of the next shipping
       day, "Order now, ships Monday"

   Shipping days are Monday to Friday minus the dates in the holiday
   attribute. The rule this fixes: a same day countdown must never run past
   the end of today. It used to roll on to the next weekday's cutoff, so a
   Sunday read "Order within 29h:12m for same-day shipping", which is a
   promise the store cannot keep.

   Every string printed here comes from the data attributes Liquid wrote on
   the row. Nothing is composed from anything else, and the sentence is built
   out of text nodes, so merchant copy cannot become markup.

   Why no number comes from Liquid. Liquid can only do arithmetic on the
   shop's own clock, and the cutoff is quoted in the fuel_11_timezone setting.
   Those are the same zone on this store today, but a merchant who sets a
   different one would get a first paint hours out until this file corrected
   it, and a wrong sentence is worse than a blank one. Intl knows the real
   offset for each date, so it is the only clock used, and it is also what
   keeps the line right across the November daylight saving change, on a page
   served from cache, and in a tab left open overnight.

   If Intl is missing, or the zone name in the setting is not a real IANA
   name, or no shipping day is found inside the search horizon, nothing is
   written: the row stays blank and keeps its height. Fail closed.

   When the module is hidden. The class f11-urgency--off takes the module out
   of the layout, so everything under it moves up by the module's height, 58px
   at 1440 and 74px on a narrow phone. Two things ask for it:

     a holiday, when the merchant turned "hide on holidays" on. That is read
     off the calendar date in the zone, so it is settled for the whole day:
     the page loads hidden and stays hidden, and nothing moves.

     a buy box that says the product cannot be bought. Read live from the form
     on every tick and on every change event inside it, because a variant
     picked after load never goes back through Liquid. This one is reversible
     and it does move the page mid session: pick a sold out variant and the
     module goes, pick an available one and it comes back, measured at 58px
     each way at 1440. It also fires just after first paint when a ?variant=
     link opens a sold out variant, because Liquid can only test the product,
     not the variant that link selects, so the module renders and this hides
     it. Both are accepted on purpose. A same day shipping promise on a
     variant nobody can buy is worse than the move, and the move follows a
     choice the shopper has just made rather than arriving on its own.

   Sold out and pre-order products, judged at the product level, never render
   the module in the first place.

   The loop walks the modules, not the rows, and the rows are looked up on
   every tick rather than held in a variable, because the product form is
   re-rendered on a variant change and anything bound to the old node would be
   lost with it. Walking the modules is what keeps the sold out guard working
   when the countdown copy carries no [time] token, and when there is no
   countdown row at all because that copy is blank. The holiday hide and the
   sentence both need the attributes Liquid writes on the countdown row, so
   those only run when that row is there. */
(function () {
  if (window.f11Urgency) {
    return;
  }
  window.f11Urgency = true;

  var MODULES = '.f11-urgency';
  var ROW = '.f11-urgency__row--countdown[data-f11-zone]';
  var OFF = 'f11-urgency--off';
  var PENDING = 'f11-urgency__text--pending';
  var TIME_TOKEN = '[time]';
  var DAY_TOKEN = '[day]';

  /* far enough that a block of holidays around Christmas plus the weekends
     either side cannot exhaust it */
  var SEARCH_DAYS = 60;

  /* under this much time left, the line is one tick away from changing, so
     the tick goes to once a second and the switch lands on time */
  var FAST_WINDOW = 120000;

  var timer = null;

  /* offset of a zone from UTC, in ms, at the instant ts */
  function zoneOffset(ts, zone) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    var parts = {};
    fmt.formatToParts(new Date(ts)).forEach(function (part) {
      parts[part.type] = part.value;
    });
    var asUTC = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour) % 24,
      Number(parts.minute),
      Number(parts.second)
    );
    return asUTC - ts;
  }

  /* epoch ms of a wall clock time in a zone, solved in two passes so that a
     date sitting on a daylight saving boundary lands on the right side of it */
  function epochOf(year, month, day, hour, minute, zone) {
    var guess = Date.UTC(year, month - 1, day, hour, minute, 0);
    var ts = guess - zoneOffset(guess, zone);
    return guess - zoneOffset(ts, zone);
  }

  /* the calendar date, in the zone, of the instant ts */
  function zoneDate(ts, zone) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: zone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    var parts = {};
    fmt.formatToParts(new Date(ts)).forEach(function (part) {
      parts[part.type] = part.value;
    });
    return [Number(parts.year), Number(parts.month), Number(parts.day)];
  }

  function pad(value) {
    return (value < 10 ? '0' : '') + value;
  }

  function dateKey(date) {
    return date[0] + '-' + pad(date[1]) + '-' + pad(date[2]);
  }

  /* the calendar date count days after the given one */
  function addDays(date, count) {
    var moved = new Date(Date.UTC(date[0], date[1] - 1, date[2] + count));
    return [moved.getUTCFullYear(), moved.getUTCMonth() + 1, moved.getUTCDate()];
  }

  /* the holidays the merchant typed. One date per line, YYYY-MM-DD, anything
     after the date on the line ignored so a name can sit beside it. Blank
     lines, stray spaces, CRLF endings and lines that are not a date are all
     dropped rather than breaking the list. */
  function holidaysOf(raw) {
    var days = {};
    if (!raw) {
      return days;
    }
    var lines = String(raw).split(/\r\n|\r|\n/);
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i].replace(/^\s+/, '').replace(/\s+$/, '');
      if (!line) {
        continue;
      }
      var found = /^(\d{4})-(\d{2})-(\d{2})(?:\s|$)/.exec(line);
      if (!found) {
        continue;
      }
      var month = Number(found[2]);
      var day = Number(found[3]);
      if (month < 1 || month > 12 || day < 1 || day > 31) {
        continue;
      }
      days[found[1] + '-' + found[2] + '-' + found[3]] = true;
    }
    return days;
  }

  function isShippingDay(date, holidays) {
    var weekday = new Date(Date.UTC(date[0], date[1] - 1, date[2])).getUTCDay();
    if (weekday < 1 || weekday > 5) {
      return false;
    }
    return !holidays[dateKey(date)];
  }

  /* the first shipping day strictly after the given date, or null */
  function nextShippingDay(date, holidays) {
    for (var i = 1; i <= SEARCH_DAYS; i++) {
      var day = addDays(date, i);
      if (isShippingDay(day, holidays)) {
        return day;
      }
    }
    return null;
  }

  /* the weekday name of a date, read in the zone the cutoff is quoted in and
     in the page's own language, so the sentence matches the rest of the page */
  function weekdayName(date, zone) {
    var noon = new Date(epochOf(date[0], date[1], date[2], 12, 0, zone));
    var lang = document.documentElement.getAttribute('lang');
    if (lang) {
      try {
        return new Intl.DateTimeFormat(lang, {
          timeZone: zone,
          weekday: 'long'
        }).format(noon);
      } catch (e) {
        /* a lang attribute that is not a real locale, fall through to en */
      }
    }
    return new Intl.DateTimeFormat('en', {
      timeZone: zone,
      weekday: 'long'
    }).format(noon);
  }

  function format(ms) {
    var total = Math.floor(ms / 1000);
    var hours = Math.floor(total / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    return hours + 'h:' + pad(minutes) + 'm';
  }

  function attr(row, name) {
    return row.getAttribute(name) || '';
  }

  /* what row one must say right now, as the text before the number, the
     number, and the text after it. Only the countdown line has a number.
     Returns null when nothing can be said truthfully, and then the row is
     left blank. left is the ms to today's cutoff while the countdown is
     running and -1 at every other time, which is what paces the tick. */
  function lineFor(row, now, holidays) {
    var hour = parseInt(attr(row, 'data-f11-hour'), 10);
    var minute = parseInt(attr(row, 'data-f11-minute'), 10);
    var zone = attr(row, 'data-f11-zone');

    if (!zone || isNaN(hour) || isNaN(minute)) {
      return null;
    }

    var today = zoneDate(now, zone);

    if (isShippingDay(today, holidays)) {
      var left = epochOf(today[0], today[1], today[2], hour, minute, zone) - now;
      if (left >= 60000) {
        var copy = attr(row, 'data-f11-text-countdown');
        var at = copy.indexOf(TIME_TOKEN);
        if (at === -1) {
          /* copy the merchant wrote without [time]. There is no number to
             keep current, so the line is printed as typed, which is also what
             Liquid painted. Saying it here rather than returning nothing puts
             the line back after a night outside the window. */
          return { before: copy, number: '', after: '', left: left };
        }
        return {
          before: copy.slice(0, at),
          number: format(left),
          after: copy.slice(at + TIME_TOKEN.length),
          left: left
        };
      }
      if (left > 0) {
        return {
          before: attr(row, 'data-f11-text-last-minute'),
          number: '',
          after: '',
          left: left
        };
      }
    }

    var next = nextShippingDay(today, holidays);
    if (!next) {
      return null;
    }
    var nextCopy = attr(row, 'data-f11-text-next-day');
    var dayAt = nextCopy.indexOf(DAY_TOKEN);
    if (dayAt !== -1) {
      nextCopy =
        nextCopy.slice(0, dayAt) +
        weekdayName(next, zone) +
        nextCopy.slice(dayAt + DAY_TOKEN.length);
    }
    return { before: nextCopy, number: '', after: '', left: -1 };
  }

  /* the buy box around this module says the product cannot be bought: the
     theme disables the button and marks the form on a sold out variant, and
     shows the pre-order note on a pre-order one. Read live, because a variant
     picked after load never goes back through Liquid. Needs no settings, so
     it works on any module the snippet rendered. */
  function buyBoxOff(module) {
    var form = module.closest ? module.closest('form') : null;
    if (!form) {
      return false;
    }
    if (form.classList && form.classList.contains('product-form--variant-sold-out')) {
      return true;
    }
    var button = form.querySelector('[data-add-to-cart]');
    if (button) {
      if (button.disabled) {
        return true;
      }
      if (button.getAttribute('aria-disabled') === 'true') {
        return true;
      }
    }
    var preOrder = form.querySelector('.pre_order_text');
    if (preOrder && preOrder.classList && !preOrder.classList.contains('hide')) {
      return true;
    }
    return false;
  }

  /* write the sentence, and only when it has actually changed, so the DOM is
     touched once a minute rather than once a tick */
  function paint(row, line) {
    var text = row.querySelector('.f11-urgency__text');
    if (!text || !line) {
      return;
    }
    var stamp = line.before + '' + line.number + '' + line.after;
    if (text.getAttribute('data-f11-said') !== stamp) {
      text.setAttribute('data-f11-said', stamp);
      while (text.firstChild) {
        text.removeChild(text.firstChild);
      }
      if (line.before) {
        text.appendChild(document.createTextNode(line.before));
      }
      if (line.number) {
        var strong = document.createElement('strong');
        strong.className = 'f11-urgency__time';
        strong.appendChild(document.createTextNode(line.number));
        text.appendChild(strong);
      }
      if (line.after) {
        text.appendChild(document.createTextNode(line.after));
      }
    }
    if (text.classList) {
      text.classList.remove(PENDING);
    }
  }

  function tick() {
    var modules = document.querySelectorAll(MODULES);
    var now = Date.now();
    var fast = false;
    var counted = 0;

    for (var i = 0; i < modules.length; i++) {
      var module = modules[i];
      var row = module.querySelector(ROW);
      var hide = buyBoxOff(module);
      var line = null;

      if (row && window.Intl && Intl.DateTimeFormat) {
        try {
          var holidays = holidaysOf(row.getAttribute('data-f11-holidays'));
          if (row.getAttribute('data-f11-hide-on-holidays') === 'true') {
            if (holidays[dateKey(zoneDate(now, attr(row, 'data-f11-zone')))]) {
              hide = true;
            }
          }
          line = lineFor(row, now, holidays);
        } catch (e) {
          /* a zone name that is not a real zone. Nothing truthful to say, so
             the row stays blank and the sentence never appears. */
          line = null;
        }
      }

      if (module.classList) {
        if (hide) {
          module.classList.add(OFF);
        } else {
          module.classList.remove(OFF);
        }
      }

      if (row) {
        counted++;
        paint(row, line);
      }

      if (line && line.left >= 0 && line.left < FAST_WINDOW) {
        fast = true;
      }
    }

    /* only a countdown row needs waking. A module with no countdown row has
       nothing that goes stale on the clock, and its buy box guard is driven
       by the change event instead. */
    if (counted) {
      schedule(fast);
    }
  }

  /* wake on the minute boundary, so the number is never stale and the page is
     not woken once a second for a value that only changes once a minute. In
     the last two minutes before a cutoff wake on the second instead, so the
     switch to the last minute line, and the switch to the next day line at
     the cutoff itself, land within a second of the time they name. A tab left
     open across the cutoff flips on its own. */
  function schedule(fast) {
    if (timer) {
      clearTimeout(timer);
    }
    var now = Date.now();
    var delay = fast ? 1000 - (now % 1000) + 50 : 60000 - (now % 60000) + 250;
    timer = setTimeout(tick, delay);
  }

  /* a variant switch rewrites the buy box, so the module is re-read as soon
     as anything in the form around it changes */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') {
      return;
    }
    var form = target.closest('form');
    if (form && form.querySelector(MODULES)) {
      setTimeout(tick, 0);
    }
  });

  window.addEventListener('pagehide', function () {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  });

  /* pagehide stops the timer and this starts it again. A page held in the
     back forward cache comes back with its timer frozen and its sentence as
     old as the moment the shopper left it, which after the cutoff is a same
     day promise that has already run out, so the line is decided again on
     every show. Safari and Firefox restore from that cache by default and
     Chrome does on a real profile, and tapping a product then going back to
     the collection and forward again is an ordinary thing to do. Fires on a
     normal load too, where it is a second tick that finds nothing changed. */
  window.addEventListener('pageshow', function () {
    tick();
  });

  /* A tab left in the background has its timers throttled. Chrome clamps a
     tab hidden for more than five minutes to one wake a minute, so a wake
     this file asks for in one second can be granted in sixty. Measured on
     the rendered page, that leaves row one promising same day shipping for
     up to a minute after the cutoff has passed, which is the same false
     promise this file exists to stop, only smaller. The throttle is lifted
     the moment the tab comes back, so the line is decided again on the way
     in rather than waiting for a wake that is still owed. focus sits beside
     it for the engines that restore a tab without firing visibilitychange.
     Both are a second tick on a page that was never hidden, and neither can
     move the page: tick only ever rewrites row one's sentence. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      tick();
    }
  });

  window.addEventListener('focus', function () {
    tick();
  });

  tick();
})();
